type Position = "top" | "middle" | "bottom";

// DL4.10 Top banner impression.
export function dataLayerTopBannerImpression(bannerId: string, creative: string) {
    dataLayer.push({
        impression: {
            promos: [
                {
                    id: bannerId,
                    name: "sazkaklub.toppopup",
                    creative: creative,
                    position: "sazkaklub.top",
                },
            ],
        },
    });
}

// DL4.11a Clicking on top banner
export function dataLayerTopBannerClick(bannerId: string, creative: string) {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.toppopup",
                        creative: creative,
                        position: "sazkaklub.top",
                    },
                ],
            },
        },
    });
}

// DL4.11b Clicking on top banner
export function dataLayerTopBannerClose(bannerId: string, creative: string) {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: `${bannerId}.close`,
                        name: "sazkaklub.toppopup",
                        creative: creative,
                        position: "sazkaklub.top",
                    },
                ],
            },
        },
    });
}

// DL4.20 Player data banner impression
export function dataLayerPlayerBannerImpression(bannerId: string, creative: string, position: Position) {
    dataLayer.push({
        event: "action.impress.promos",
        action: {
            impress: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.playerData.popup",
                        creative: creative,
                        position: `sazkaklub.home.${position}`,
                    },
                ],
            },
        },
    });
}

// DL4.21 Player data banner click
export function dataLayerPlayerBannerClick(bannerId: string, creative: string, position: Position) {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.playerData.popup",
                        creative: creative,
                        position: `sazkaklub.home.${position}`,
                    },
                ],
            },
        },
    });
}

// DL4.30 Home page banner impression
export function dataLayerHPBannerImpression(bannerId: string, creative: string, orderNumber: string) {
    dataLayer.push({
        event: "action.impress.promos",
        action: {
            impress: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.home.banner",
                        creative: creative,
                        position: `sazkaklub.home.${orderNumber}`,
                    },
                ],
            },
        },
    });
}

// DL4.31 Home page banner click
export function dataLayerHPBannerClick(bannerId: string, creative: string, orderNumber: string) {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.home.banner",
                        creative: creative,
                        position: `sazkaklub.home.${orderNumber}`,
                    },
                ],
            },
        },
    });
}

// DL4.40 SMS Spin banner impression
export function dataLayerSMSBannerImpression(bannerId: string, creative: string, position: Position) {
    dataLayer.push({
        event: "action.impress.promos",
        action: {
            impress: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.sms.spin",
                        creative: creative,
                        position: `sazkaklub.sms.spin.${position}`,
                    },
                ],
            },
        },
    });
}

// DL4.41 SMS Spin banner click
export function dataLayerSMSBannerClick(bannerId: string, creative: string, position: Position) {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.sms.spin",
                        creative: creative,
                        position: `sazkaklub.sms.spin.${position}`,
                    },
                ],
            },
        },
    });
}
